import { render, staticRenderFns } from "./StepCredentials.vue?vue&type=template&id=0b907a6c&scoped=true&"
import script from "./StepCredentials.vue?vue&type=script&lang=ts&"
export * from "./StepCredentials.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b907a6c",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VForm } from 'vuetify/lib/components/VForm';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VForm,VSpacer})


/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0b907a6c')) {
      api.createRecord('0b907a6c', component.options)
    } else {
      api.reload('0b907a6c', component.options)
    }
    module.hot.accept("./StepCredentials.vue?vue&type=template&id=0b907a6c&scoped=true&", function () {
      api.rerender('0b907a6c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/organisms/wizard/StepCredentials.vue"
export default component.exports